import * as React from "react";
import { Trans, useTranslation } from "react-i18next";
import classNames from "classnames";
import { OverlayTrigger } from "components/common";
const ShardRouting = ({ route }) => {
  const { t } = useTranslation("indexsets");
  const tooltip = /* @__PURE__ */ React.createElement(
    Trans,
    {
      t,
      i18nKey: "shards.tooltip",
      values: { state: route.state, hostname: route.node_hostname, name: route.node_name },
      components: { i: /* @__PURE__ */ React.createElement("i", null) }
    }
  );
  return /* @__PURE__ */ React.createElement("li", { className: classNames("shard", `shard-${route.state}`, { "shard-primary": route.primary }) }, /* @__PURE__ */ React.createElement(OverlayTrigger, { placement: "top", overlay: tooltip }, /* @__PURE__ */ React.createElement("span", { className: "id" }, t("shards.shard_id", { id: route.id }))));
};
export default ShardRouting;
